// Mock data per gli 8 premi La Saponaria
export const rewardsData = {
  '1': {
    id: '1',
    code: 'SIERO-HA-001',
    name: 'Siero Acido Ialuronico Multi-Peso',
    type: 'Prodotto Viso',
    status: 'Attivo',
    cost: 50,
    description:
      'Siero viso con acido ialuronico a tre pesi molecolari per idratazione profonda e effetto rimpolpante.',
    terms:
      'Valido presso tutte le sedi La Saponaria. Ritiro in negozio entro 30 giorni dal riscatto.',
    availability: {
      current: 45,
      total: 100,
      unlimited: false,
    },
    redemptions: {
      period: 28,
      total: 234,
      lastRedemption: '2 ore fa',
    },
    location: 'Milano Centro',
    startDate: '2024-01-01',
    endDate: '2024-12-31',
    limitPerUser: true,
    locations: ['Milano Centro', 'Roma Cola di Rienzo', 'Bologna'],
    aiHint: null,
    performanceData: [
      { date: '1 Gen', value: 15 },
      { date: '5 Gen', value: 18 },
      { date: '10 Gen', value: 22 },
      { date: '15 Gen', value: 28 },
      { date: '20 Gen', value: 32 },
      { date: '25 Gen', value: 35 },
      { date: '30 Gen', value: 40 },
    ],
  },
  '2': {
    id: '2',
    code: 'SOLIDI-KIT-002',
    name: 'Kit Cosmetici Solidi Zero Waste',
    type: 'Cosmetici Solidi',
    status: 'Attivo',
    cost: 50,
    description:
      'Kit completo con shampoo solido, balsamo solido e bagnoschiuma solido. 100% naturale, plastic-free.',
    terms:
      'Valido presso tutte le sedi La Saponaria. Ritiro in negozio entro 30 giorni dal riscatto.',
    availability: {
      current: 12,
      total: 50,
      unlimited: false,
    },
    redemptions: {
      period: 22,
      total: 187,
      lastRedemption: '5 ore fa',
    },
    location: 'Roma Cola di Rienzo',
    startDate: '2024-01-15',
    endDate: '2024-06-30',
    limitPerUser: true,
    locations: ['Roma Cola di Rienzo', 'Milano Solari', 'Firenze'],
    aiHint: {
      text: 'Disponibilità bassa: aumenta stock del 40%',
      explanation:
        'Basato su 187 riscatti totali e trend crescente (+25%), questo premio sta per esaurirsi. I cosmetici solidi zero-waste sono molto richiesti.',
    },
    performanceData: [
      { date: '1 Gen', value: 12 },
      { date: '5 Gen', value: 16 },
      { date: '10 Gen', value: 19 },
      { date: '15 Gen', value: 24 },
      { date: '20 Gen', value: 28 },
      { date: '25 Gen', value: 31 },
      { date: '30 Gen', value: 38 },
    ],
  },
  '3': {
    id: '3',
    code: 'CREMA-VISO-003',
    name: 'Crema Viso Deep Care Anti-Age',
    type: 'Prodotto Viso',
    status: 'Attivo',
    cost: 50,
    description:
      'Crema viso anti-età con attivi naturali per contrastare i segni del tempo e nutrire la pelle in profondità.',
    terms:
      'Valido presso tutte le sedi La Saponaria. Ritiro in negozio entro 30 giorni dal riscatto.',
    availability: {
      current: 28,
      total: 80,
      unlimited: false,
    },
    redemptions: {
      period: 18,
      total: 156,
      lastRedemption: '1 giorno fa',
    },
    location: 'Bologna',
    startDate: '2024-02-01',
    endDate: null,
    limitPerUser: true,
    locations: ['Bologna', 'Milano Centro', 'Firenze'],
    aiHint: null,
    performanceData: [
      { date: '1 Gen', value: 10 },
      { date: '5 Gen', value: 14 },
      { date: '10 Gen', value: 16 },
      { date: '15 Gen', value: 20 },
      { date: '20 Gen', value: 22 },
      { date: '25 Gen', value: 25 },
      { date: '30 Gen', value: 28 },
    ],
  },
  '4': {
    id: '4',
    code: 'HENNE-004',
    name: 'Set Hennetica Tinte Vegetali',
    type: 'Prodotto Capelli',
    status: 'Attivo',
    cost: 60,
    description:
      'Set completo di tinte vegetali Hennetica per colorare i capelli in modo naturale e senza ammoniaca.',
    terms:
      'Valido presso tutte le sedi La Saponaria. Include consulenza gratuita. Ritiro in negozio entro 30 giorni dal riscatto.',
    availability: {
      current: 23,
      total: 60,
      unlimited: false,
    },
    redemptions: {
      period: 15,
      total: 142,
      lastRedemption: '3 ore fa',
    },
    location: 'Milano Solari',
    startDate: null,
    endDate: '2024-12-31',
    limitPerUser: true,
    locations: ['Milano Solari', 'Roma Cola di Rienzo', 'Bologna'],
    aiHint: {
      text: 'Prova ad abbassare il costo di 10 punti per aumentare i riscatti',
      explanation:
        'I premi nella fascia 45-55 punti hanno un tasso di conversione 18% più alto. Questo premio ha performance sotto la media per la sua categoria.',
    },
    performanceData: [
      { date: '1 Gen', value: 8 },
      { date: '5 Gen', value: 11 },
      { date: '10 Gen', value: 13 },
      { date: '15 Gen', value: 16 },
      { date: '20 Gen', value: 18 },
      { date: '25 Gen', value: 20 },
      { date: '30 Gen', value: 24 },
    ],
  },
  '5': {
    id: '5',
    code: 'WORK-005',
    name: 'Workshop Cosmetici Fai-da-Te',
    type: 'Esperienza',
    status: 'Programmato',
    cost: 100,
    description:
      'Workshop di 2 ore per imparare a creare cosmetici naturali fai-da-te. Include materiali e ricettario.',
    terms:
      'Workshop presso la sede di Pesaro. Prenotazione obbligatoria. Date disponibili sul sito.',
    availability: {
      current: 15,
      total: 15,
      unlimited: false,
    },
    redemptions: {
      period: 0,
      total: 0,
      lastRedemption: 'Mai',
    },
    location: 'Pesaro (Sede)',
    startDate: '2024-03-01',
    endDate: '2024-06-30',
    limitPerUser: true,
    locations: ['Pesaro (Sede)'],
    aiHint: null,
    performanceData: [],
  },
  '6': {
    id: '6',
    code: 'VOUCHER-20',
    name: 'Buono Sconto 20€ su Acquisto',
    type: 'Buono Sconto',
    status: 'Attivo',
    cost: 40,
    description:
      'Buono sconto del valore di 20€ utilizzabile su qualsiasi acquisto presso i negozi La Saponaria.',
    terms:
      'Valido presso tutte le sedi La Saponaria. Non cumulabile con altre promozioni. Valido 60 giorni dal riscatto.',
    availability: {
      current: 0,
      total: 0,
      unlimited: true,
    },
    redemptions: {
      period: 45,
      total: 312,
      lastRedemption: '1 ora fa',
    },
    location: 'Tutte le Sedi',
    startDate: null,
    endDate: null,
    limitPerUser: false,
    locations: ['Tutte le Sedi'],
    aiHint: null,
    performanceData: [
      { date: '1 Gen', value: 20 },
      { date: '5 Gen', value: 25 },
      { date: '10 Gen', value: 30 },
      { date: '15 Gen', value: 35 },
      { date: '20 Gen', value: 42 },
      { date: '25 Gen', value: 48 },
      { date: '30 Gen', value: 52 },
    ],
  },
  '7': {
    id: '7',
    code: 'CORPO-AHA-007',
    name: 'Crema Corpo AHA Levigante',
    type: 'Prodotto Corpo',
    status: 'Attivo',
    cost: 45,
    description:
      'Crema corpo con acidi della frutta (AHA) per levigare e rinnovare la pelle del corpo.',
    terms:
      'Valido presso tutte le sedi La Saponaria. Ritiro in negozio entro 30 giorni dal riscatto.',
    availability: {
      current: 34,
      total: 70,
      unlimited: false,
    },
    redemptions: {
      period: 12,
      total: 98,
      lastRedemption: '6 ore fa',
    },
    location: 'Firenze',
    startDate: '2024-01-10',
    endDate: '2024-12-31',
    limitPerUser: true,
    locations: ['Firenze', 'Bologna', 'Roma Cola di Rienzo'],
    aiHint: null,
    performanceData: [
      { date: '1 Gen', value: 6 },
      { date: '5 Gen', value: 9 },
      { date: '10 Gen', value: 11 },
      { date: '15 Gen', value: 14 },
      { date: '20 Gen', value: 16 },
      { date: '25 Gen', value: 18 },
      { date: '30 Gen', value: 20 },
    ],
  },
  '8': {
    id: '8',
    code: 'BOX-BIO-008',
    name: 'Box Scoperta Prodotti Bio',
    type: 'Kit Prodotti',
    status: 'Inattivo',
    cost: 70,
    description:
      'Box scoperta con selezione di prodotti bio La Saponaria: viso, corpo, capelli. Perfetto per provare la linea.',
    terms:
      'Valido presso tutte le sedi La Saponaria. Ritiro in negozio entro 30 giorni dal riscatto. Contenuto variabile.',
    availability: {
      current: 8,
      total: 30,
      unlimited: false,
    },
    redemptions: {
      period: 0,
      total: 67,
      lastRedemption: '3 giorni fa',
    },
    location: 'Torino',
    startDate: '2024-01-01',
    endDate: '2024-03-31',
    limitPerUser: true,
    locations: ['Torino', 'Milano Centro', 'Bologna'],
    aiHint: null,
    performanceData: [
      { date: '1 Gen', value: 8 },
      { date: '5 Gen', value: 10 },
      { date: '10 Gen', value: 12 },
      { date: '15 Gen', value: 14 },
      { date: '20 Gen', value: 15 },
      { date: '25 Gen', value: 15 },
      { date: '30 Gen', value: 15 },
    ],
  },
}
